var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "612px",
    height: "612px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306,328.667c90.759,0,164.333-73.575,164.333-164.333S396.759,0,306,0c-90.759,0-164.333,73.575-164.333,164.333 S215.241,328.667,306,328.667z M383.878,229.376c-7.475,24.718-39.498,43.298-77.878,43.298c-38.38,0-70.403-18.581-77.878-43.298 H383.878z M583.667,498.667v54.169c0,8.029-5.912,17.359-13.246,20.624C541.993,586.109,464.45,612,306,612 c-158.451,0-235.992-25.891-264.42-38.54c-7.335-3.265-13.246-12.595-13.246-20.624v-54.169 c0-81.174,61.804-148.515,140.666-157.533c2.396-0.275,5.949,0.751,7.903,2.165c36.361,26.324,80.877,42.035,129.097,42.035 s92.738-15.711,129.097-42.035c1.955-1.414,5.508-2.44,7.904-2.165C521.862,350.152,583.667,417.493,583.667,498.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneUser);
export default __webpack_public_path__ + "static/media/one-user.4504cc7932999617dcffbf08524da97a.svg";
export { ForwardRef as ReactComponent };